module.exports = __webpack_public_path__ + "media/images/bestellen-9d31c1c9a3dd1979b20c912b4796e2e5.png";